import classNames from "classnames";

import styles from "./UI.module.css";

/* Material Design artwork (Apache-2.0), same paths the MUI icons ship. */
const BLANK =
    "M19 5v14H5V5zm0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2";
const CHECKED =
    "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z";

/**
 * Replaces MUI's <FormControlLabel control={<Checkbox/>} />, reproducing its
 * geometry: a 42x42 control (24px icon + 9px padding) pulled 11px left, which is
 * what keeps the row height and the label's x-position identical to before.
 *
 * A native checkbox is kept for behaviour and accessibility but rendered
 * transparently over the icon — `accent-color` alone cannot match MUI's artwork.
 */
export default function CheckboxField({
    checked,
    className,
    disabled = false,
    label,
    onChange,
    ...rest
}) {
    return (
        <label
            className={classNames(
                styles.checkboxLabel,
                disabled && styles.checkboxLabelDisabled,
                className,
            )}
        >
            <span className={styles.checkboxControl}>
                <input
                    checked={checked}
                    className={styles.checkboxInput}
                    disabled={disabled}
                    onChange={onChange}
                    type="checkbox"
                    {...rest}
                />
                <svg
                    aria-hidden="true"
                    className={styles.checkboxIcon}
                    focusable="false"
                    viewBox="0 0 24 24"
                >
                    <path d={checked ? CHECKED : BLANK} />
                </svg>
            </span>
            <span className={styles.checkboxText}>{label}</span>
        </label>
    );
}
